export function getSectorByLegalFormId (id) {
	return dict[id];
}

export function getDictionary () {
	return dict;
}

let dict = {
	0: "Sektor pozarządowy",
	1: "Sektor pozarządowy",
	2: "Sektor pozarządowy",
	3: "Sektor pozarządowy",
	4: "Sektor pozarządowy",
	5: "Sektor pozarządowy",
	6: "Sektor pozarządowy",
	7: "Sektor pozarządowy",
	8: "Sektor pozarządowy",
	9: "Sektor pozarządowy",
	10: "Sektor pozarządowy",
	11: "Sektor pozarządowy",
	12: "Sektor pozarządowy",

	13: "Instytucja naukowa",
	14: "Instytucja naukowa",
	15: "Instytucja naukowa",
	16: "Instytucja naukowa",
	17: "Instytucja naukowa",
	18: "Instytucja naukowa",

	19: "Organ administracji rządowej",
	20: "Organ administracji rządowej",
	21: "Organ administracji rządowej",
	22: "Organ administracji rządowej",

	23: "Jednostka samorządu terytorialnego",
	24: "Jednostka samorządu terytorialnego",
	25: "Jednostka samorządu terytorialnego",
	26: "Jednostka samorządu terytorialnego",
};